import registerLessonSidebar from "./LessonSidebar";

registerLessonSidebar();
